import * as angular from "angular"; 

import { AccountModel } from "./Common/Models/AccountModel"
import "./Common/Models/AccountModel"
import "./Common/Layout/SinglePaneLayout";

class HomeAppController implements angular.IController {
	public Message: String; 

	constructor(private accountModel: AccountModel,private $window: angular.IWindowService) {

	}

	public $onInit() { }
}

angular.module('homeApp', ['directives'])
	.controller('homeController', ['accountModel', '$window', (accountModel, $window) => new HomeAppController(accountModel, $window)]);


// WEBPACK FOOTER //
// ./homeApp.ts